import React, { useState } from 'react';
import { Wizard, Steps, Step } from 'react-albus';
import IdCellStep from './IdCellStep';
import AlreadyRegisteredStep from './AlreadyRegisteredStep';
import NotIsraeliStep from './NotIsraeliStep';
import SendPasswordStep from './SendPasswordStep';

export default function InitialRegistration({ goToStepsRegistration, labels }) {

  return (
    <div>
      <h1 className="mb-5">{labels.title}</h1>
      <Wizard>
        <Steps>
          <Step
            id="id_cell"
            render={({ next, push }) => (
              <IdCellStep labels={labels} next={next} push={push} />
            )}
          />
          <Step
            id="not_israeli"
            render={({ next }) => (
              <NotIsraeliStep labels={labels} next={next} />
            )}
          />
          <Step
            id="already_registered"
            render={({ push }) => (
              <AlreadyRegisteredStep labels={labels} push={push} goToStepsRegistration={goToStepsRegistration} />
            )}
          />
          <Step
            id="send_password"
            render={({ next }) => (
              <SendPasswordStep labels={labels} goToStepsRegistration={goToStepsRegistration} />
            )}
          />
        </Steps>
      </Wizard>
    </div>
  )
}